export const sellMarketingBuyCarClicked =  {
    event: "sell_marketing_buy_car_clicked",
    eventCategory: "Sell-marketing",
    eventAction: "Buy a car clicked"
};
